export { default } from './Dynamictable';
